export default "__VITE_ASSET__CB7DIMZ$__"